export const LOCATION_UPDATE_THROTTLE_MS = 90_000;
export const MINIMUM_MOVEMENT_METERS = 50;